import { render } from "./BaseRouterLink.vue?vue&type=template&id=54748ca9"
import script from "./BaseRouterLink.vue?vue&type=script&lang=js"
export * from "./BaseRouterLink.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__